// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress__XotoK"};